import React, { useState } from "react";
import "./faq.css";

const faqData = [
  {
    question: "Do you offer custom solutions?",
    answer: "Yes, every project is tailored to your unique business needs."
  },
  {
    question: "How do I get started?",
    answer: "Simply contact us and we’ll schedule a consultation."
  },
  {
    question: "Do you provide ongoing support?",
    answer: "Absolutely. We continuously optimize and provide long-term support."
  },
  {
    question: "What industries do you serve?",
    answer: "We work across multiple industries including IT, retail, manufacturing, and more."
  }
];

export default function FAQSection() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq">
      <h2>Frequently Asked Questions</h2>
      <div className="faq-list">
        {faqData.map((item, index) => (
          <div key={index} className="faq-item">
            <button
              className={`faq-question ${activeIndex === index ? "active" : ""}`}
              onClick={() => toggleFAQ(index)}
            >
              {item.question}
              <span className="faq-toggle">{activeIndex === index ? "-" : "+"}</span>
            </button>
            <div
              className={`faq-answer ${activeIndex === index ? "open" : ""}`}
            >
              <p>{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
